











import CoIcon from '../co-icon/CoIcon.vue';
import { get } from 'lodash';
export default {
    name: 'CoFileInput',
    components: { CoIcon },
    props: {
        accept: {
            type: String,
            default: '', // i.e. 'image/jpeg,image/png', '.png,.doc,.pdf' values according to https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: 'cloud-upload',
        },
    },
    methods: {
        fileSelect(event) {
            // Copy the current selection before clearing the native input so re-selecting the same file triggers change again.
            const files = Array.from(get(event, 'target.files') || []);
            if (event && event.target) {
                event.target.value = '';
            }
            this.$emit('change', files);
        },
    },
};
